import TranscriptView from '@components/transcript/TranscriptView';
import { useTranscriptViewController } from './useTranscriptViewController';

export default function TranscriptViewController({ transcript, searchQuery = '' }) {
  const viewModel = useTranscriptViewController({ transcript, searchQuery });
  return <TranscriptView {...viewModel} />;
}
